import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { SgzpApp4ChangePasswordSentComponent } from './sgzp-app4-change-password-sent/sgzp-app4-change-password-sent.component';
import { SgzpApp4ForgotPasswordComponent } from './sgzp-app4-forgot-password/sgzp-app4-forgot-password.component';
import { SgzpApp4InputComponent } from './sgzp-app4-input/sgzp-app4-input.component';
import { SgzpApp4LoginComponent } from './sgzp-app4-login/sgzp-app4-login.component';
import { SgzpApp4PasswordInputComponent } from './sgzp-app4-password-input/sgzp-app4-password-input.component';
import { SgzpApp4RegisterResendComponent } from './sgzp-app4-register-resend/sgzp-app4-register-resend.component';
import { SgzpApp4RegisterSendComponent } from './sgzp-app4-register-send/sgzp-app4-register-send.component';
import { SgzpApp4RegisterComponent } from './sgzp-app4-register/sgzp-app4-register.component';
import { SgzpApp4ResetPasswordComponent } from './sgzp-app4-reset-password/sgzp-app4-reset-password.component';
import { SgzpApp4UnblockComponent } from './sgzp-app4-unblock/sgzp-app4-unblock.component';
import { SgzpApp4Component } from './sgzp-app4/sgzp-app4.component';

@NgModule({
  declarations: [
    SgzpApp4Component,
    SgzpApp4LoginComponent,
    SgzpApp4RegisterComponent,
    SgzpApp4UnblockComponent,
    SgzpApp4RegisterResendComponent,
    SgzpApp4RegisterSendComponent,
    SgzpApp4ForgotPasswordComponent,
    SgzpApp4ResetPasswordComponent,
    SgzpApp4ChangePasswordSentComponent,
    SgzpApp4InputComponent,
    SgzpApp4PasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SgzpApp4ResetPasswordComponent,
    SgzpApp4Component,
    SgzpApp4RegisterResendComponent,
    SgzpApp4RegisterSendComponent,
    SgzpApp4UnblockComponent,
    SgzpApp4ChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SgzpApp4Module { }
